import { useQuery } from "@tanstack/react-query";
import { useEffect, useMemo, useState } from "react";
import { withNamespaces } from "react-i18next";
import { toast } from "react-toastify";
import TableFilter from "src/components/TableFilter";
import CommonService from "src/modules/data-protection/apis/CommonService";

const FilteringComponent = ({
  t,
  lng,
  onChange,
  queryEnabled = true,
}) => {
  const [tableFilters, setTableFilters] = useState({
    legalEntityIds: undefined,
  });

  const { data: legalEntities, isFetching: entitiesAreFetching } = useQuery({
    queryKey: ["data-protection-fetch-all-legal-entities-list", lng],
    queryFn: async () => {
      const service = CommonService.getInstance();
      return await service.fetchAllLegalEntities();
    },
    enabled: queryEnabled,
    cacheTime: 0,
    refetchOnWindowFocus: false,
    onError: () => {
      toast(t("An error occurred while fetching entities."), {
        type: "error",
      });
    },
  });

  const tableFilterTabs = useMemo(() => {
    return [
      {
        type: "check_list",
        name: "legalEntityIds",
        title: "Connected Legal Entities",
        icon: <i className="ri-git-branch-line" />,
        isLoading: entitiesAreFetching,
        defaultValue: tableFilters?.legalEntityIds,
        data: legalEntities?.legalEntities || [],
        searchInListOption: {
          enabled: true,
          remote: false,
        },
        formatter: (item) => {
          return item.title;
        },
      },
    ];
  }, [tableFilters, entitiesAreFetching, legalEntities, t]);

  const onTableFilterOkButtonClicked = (filters) => {
    if (filters) {
      setTableFilters({
        legalEntityIds:
          filters.legalEntityIds !== "all" ? filters.legalEntityIds : undefined,
      });
    } else {
      setTableFilters({ legalEntityIds: undefined });
    }
  };

  useEffect(() => {
    onChange?.({ legalEntityIds: tableFilters.legalEntityIds });
  }, [tableFilters, onChange]);

  return (
    <TableFilter
      className="me-2 controls-filter"
      defaultActiveTab="legalEntityIds"
      tabs={tableFilterTabs}
      onOkButtonClicked={onTableFilterOkButtonClicked}
    />
  );
};

export default withNamespaces()(FilteringComponent);
